import { streamCanvasEdit } from "./canvasEdit";
import { suggestNodeStream } from "./suggestNode";
import { streamChatResponse } from "./chatService";
export * from "./chatSchema";
export * from "./schema";

const ZslCreator = {
  suggestNodeStream,
  streamCanvasEdit,
  streamChatResponse,
};

export { ZslCreator };
